export default function preloaderGame3 (scene) {

    scene.load.image(`tilesgame3`, `/tiles/game3.png`);
    scene.load.image(`noLightstickgame3`, `/tiles/noLightstick-game3.png`);

	scene.load.audio("flyhighSong", ["/audio/songs/3-flyhigh.mp3"]);

	scene.load.spritesheet(`jiu-game3`, 
		`/img/game3/jiu.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	scene.load.spritesheet(`sua-game3`, 
		`/img/game3/sua.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	scene.load.spritesheet(`siyeon-game3`, 
		`/img/game3/siyeon.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`handong-game3`, 
		`/img/game3/handong.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`yoohyeon-game3`, 
		`/img/game3/yoohyeon.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	scene.load.spritesheet(`dami-game3`, 
		`/img/game3/dami.png`,
		{ frameWidth: 25, frameHeight: 37}
	);
	
	scene.load.spritesheet(`gahyeon-game3`, 
		`/img/game3/gahyeon.png`,
		{ frameWidth: 25, frameHeight: 37}
	);

	scene.load.spritesheet(`enemy-game3`, 
		`/img/game3/enemy-2.png`,
		{ frameWidth: 79, frameHeight: 70}
	);

	scene.load.tilemapTiledJSON(`game3`, `/tiles/game3.tmj`);

}